import { rpx } from 'client/lib/rpx-client';

export type CheckoutErrorStep = 'load' | 'checkout' | 'upsell';

export function reportCheckoutError(opts: {
  step: CheckoutErrorStep;
  priceId: string;
  err: unknown;
}) {
  const err = opts.err as
    | { message?: unknown; type?: unknown; code?: unknown; statusCode?: unknown }
    | undefined;
  const message = typeof err?.message === 'string' ? err.message : String(opts.err);
  rpx.courseCheckout
    .reportClientError({
      step: opts.step,
      priceId: opts.priceId,
      message: message.slice(0, 1024),
      type: typeof err?.type === 'string' ? err.type.slice(0, 64) : undefined,
      code: typeof err?.code === 'string' ? err.code.slice(0, 64) : undefined,
      statusCode: typeof err?.statusCode === 'number' ? err.statusCode : undefined,
    })
    .catch(console.error);
}
